import { Locale } from "@/lib/i18n";

type DevToolCopy = {
  encode: string;
  decode: string;
  outputResult: string;
  invalidInput: string;
  copyOutput: string;
  textToEncode: string;
  base64ToDecode: string;
  enterTextToEncode: string;
  enterBase64ToDecode: string;
  encodeToBase64: string;
  decodeFromBase64: string;
  urlToEncode: string;
  encodedUrlToDecode: string;
  encodeUrl: string;
  decodeUrl: string;
  uuidVersion: string;
  quantity: string;
  aboutUuidVersions: string;
  version4: string;
  version4Body: string;
  version1: string;
  version1Body: string;
  generateUuid: string;
  generateUuids: string;
  results: string;
  copyAll: string;
};

const en: DevToolCopy = {
  encode: "Encode",
  decode: "Decode",
  outputResult: "Output Result",
  invalidInput: "Invalid input",
  copyOutput: "Copy output",
  textToEncode: "Text to Encode",
  base64ToDecode: "Base64 to Decode",
  enterTextToEncode: "Enter text to encode...",
  enterBase64ToDecode: "Enter Base64 string to decode...",
  encodeToBase64: "Encode to Base64",
  decodeFromBase64: "Decode from Base64",
  urlToEncode: "URL to Encode",
  encodedUrlToDecode: "Encoded URL to Decode",
  encodeUrl: "Encode URL",
  decodeUrl: "Decode URL",
  uuidVersion: "UUID Version",
  quantity: "Quantity",
  aboutUuidVersions: "About UUID Versions",
  version4: "Version 4",
  version4Body: "Randomly generated. Most common for general use.",
  version1: "Version 1",
  version1Body: "Generated from timestamp and machine data.",
  generateUuid: "Generate UUID",
  generateUuids: "Generate UUIDs",
  results: "Results",
  copyAll: "Copy All",
};

const overrides: Partial<Record<Locale, Partial<DevToolCopy>>> = {
  id: {
    encode: "Encode",
    decode: "Decode",
    outputResult: "Hasil Output",
    invalidInput: "Input tidak valid",
    copyOutput: "Salin hasil",
    textToEncode: "Teks untuk Di-encode",
    base64ToDecode: "Base64 untuk Di-decode",
    enterTextToEncode: "Masukkan teks untuk di-encode...",
    enterBase64ToDecode: "Masukkan string Base64 untuk di-decode...",
    encodeToBase64: "Encode ke Base64",
    decodeFromBase64: "Decode dari Base64",
    urlToEncode: "URL untuk Di-encode",
    encodedUrlToDecode: "URL Terenkode untuk Di-decode",
    encodeUrl: "Encode URL",
    decodeUrl: "Decode URL",
    uuidVersion: "Versi UUID",
    quantity: "Jumlah",
    aboutUuidVersions: "Tentang Versi UUID",
    version4: "Versi 4",
    version4Body: "Dibuat secara acak. Paling umum untuk penggunaan umum.",
    version1: "Versi 1",
    version1Body: "Dibuat dari timestamp dan data mesin.",
    generateUuid: "Buat UUID",
    generateUuids: "Buat UUID",
    results: "Hasil",
    copyAll: "Salin Semua",
  },
  vi: {
    outputResult: "Kết quả",
    invalidInput: "Dữ liệu không hợp lệ",
    copyOutput: "Sao chép kết quả",
    textToEncode: "Văn bản cần mã hóa",
    base64ToDecode: "Base64 cần giải mã",
    enterTextToEncode: "Nhập văn bản cần mã hóa...",
    enterBase64ToDecode: "Nhập chuỗi Base64 cần giải mã...",
    encodeToBase64: "Mã hóa sang Base64",
    decodeFromBase64: "Giải mã từ Base64",
    urlToEncode: "URL cần mã hóa",
    encodedUrlToDecode: "URL đã mã hóa cần giải mã",
    encodeUrl: "Mã hóa URL",
    decodeUrl: "Giải mã URL",
    uuidVersion: "Phiên bản UUID",
    quantity: "Số lượng",
    aboutUuidVersions: "Về các phiên bản UUID",
    version4Body: "Được tạo ngẫu nhiên. Phổ biến nhất cho nhu cầu chung.",
    version1Body: "Được tạo từ dấu thời gian và dữ liệu máy.",
    generateUuid: "Tạo UUID",
    generateUuids: "Tạo UUID",
    results: "Kết quả",
    copyAll: "Sao chép tất cả",
  },
  cs: {
    outputResult: "Výsledek",
    invalidInput: "Neplatný vstup",
    copyOutput: "Kopírovat výstup",
    textToEncode: "Text k zakódování",
    base64ToDecode: "Base64 k dekódování",
    enterTextToEncode: "Zadejte text k zakódování...",
    enterBase64ToDecode: "Zadejte řetězec Base64 k dekódování...",
    encodeToBase64: "Zakódovat do Base64",
    decodeFromBase64: "Dekódovat z Base64",
    urlToEncode: "URL k zakódování",
    encodedUrlToDecode: "Zakódovaná URL k dekódování",
    encodeUrl: "Zakódovat URL",
    decodeUrl: "Dekódovat URL",
    uuidVersion: "Verze UUID",
    quantity: "Počet",
    aboutUuidVersions: "O verzích UUID",
    version4Body: "Náhodně generováno. Nejčastější pro běžné použití.",
    version1Body: "Vytvářeno z časového razítka a dat zařízení.",
    generateUuid: "Vygenerovat UUID",
    generateUuids: "Vygenerovat UUID",
    results: "Výsledky",
    copyAll: "Kopírovat vše",
  },
  es: {
    outputResult: "Resultado",
    invalidInput: "Entrada no válida",
    copyOutput: "Copiar resultado",
    textToEncode: "Texto para codificar",
    base64ToDecode: "Base64 para decodificar",
    enterTextToEncode: "Ingresa el texto para codificar...",
    enterBase64ToDecode: "Ingresa la cadena Base64 para decodificar...",
    encodeToBase64: "Codificar a Base64",
    decodeFromBase64: "Decodificar desde Base64",
    urlToEncode: "URL para codificar",
    encodedUrlToDecode: "URL codificada para decodificar",
    encodeUrl: "Codificar URL",
    decodeUrl: "Decodificar URL",
    uuidVersion: "Versión UUID",
    quantity: "Cantidad",
    aboutUuidVersions: "Sobre las versiones UUID",
    version4Body: "Generado aleatoriamente. El más común para uso general.",
    version1Body: "Generado a partir de marca de tiempo y datos de la máquina.",
    generateUuid: "Generar UUID",
    generateUuids: "Generar UUID",
    results: "Resultados",
    copyAll: "Copiar todo",
  },
  fr: {
    outputResult: "Résultat",
    invalidInput: "Entrée non valide",
    copyOutput: "Copier le résultat",
    textToEncode: "Texte à encoder",
    base64ToDecode: "Base64 à décoder",
    enterTextToEncode: "Saisissez le texte à encoder...",
    enterBase64ToDecode: "Saisissez la chaîne Base64 à décoder...",
    encodeToBase64: "Encoder en Base64",
    decodeFromBase64: "Décoder depuis Base64",
    urlToEncode: "URL à encoder",
    encodedUrlToDecode: "URL encodée à décoder",
    encodeUrl: "Encoder l'URL",
    decodeUrl: "Décoder l'URL",
    uuidVersion: "Version UUID",
    quantity: "Quantité",
    aboutUuidVersions: "À propos des versions UUID",
    version4Body: "Générée aléatoirement. La plus courante pour un usage général.",
    version1Body: "Générée à partir d'un horodatage et de données machine.",
    generateUuid: "Générer UUID",
    generateUuids: "Générer des UUID",
    results: "Résultats",
    copyAll: "Tout copier",
  },
  de: {
    outputResult: "Ausgabe",
    invalidInput: "Ungültige Eingabe",
    copyOutput: "Ausgabe kopieren",
    textToEncode: "Zu codierender Text",
    base64ToDecode: "Zu decodierendes Base64",
    enterTextToEncode: "Text zum Codieren eingeben...",
    enterBase64ToDecode: "Base64-Zeichenfolge zum Decodieren eingeben...",
    encodeToBase64: "In Base64 codieren",
    decodeFromBase64: "Aus Base64 decodieren",
    urlToEncode: "Zu codierende URL",
    encodedUrlToDecode: "Zu decodierende codierte URL",
    encodeUrl: "URL codieren",
    decodeUrl: "URL decodieren",
    uuidVersion: "UUID-Version",
    quantity: "Menge",
    aboutUuidVersions: "Über UUID-Versionen",
    version4Body: "Zufällig generiert. Am häufigsten für allgemeine Zwecke.",
    version1Body: "Aus Zeitstempel und Maschinendaten erzeugt.",
    generateUuid: "UUID erzeugen",
    generateUuids: "UUIDs erzeugen",
    results: "Ergebnisse",
    copyAll: "Alles kopieren",
  },
  it: {
    outputResult: "Risultato",
    invalidInput: "Input non valido",
    copyOutput: "Copia risultato",
    textToEncode: "Testo da codificare",
    base64ToDecode: "Base64 da decodificare",
    enterTextToEncode: "Inserisci il testo da codificare...",
    enterBase64ToDecode: "Inserisci la stringa Base64 da decodificare...",
    encodeToBase64: "Codifica in Base64",
    decodeFromBase64: "Decodifica da Base64",
    urlToEncode: "URL da codificare",
    encodedUrlToDecode: "URL codificato da decodificare",
    encodeUrl: "Codifica URL",
    decodeUrl: "Decodifica URL",
    uuidVersion: "Versione UUID",
    quantity: "Quantità",
    aboutUuidVersions: "Informazioni sulle versioni UUID",
    version4Body: "Generata casualmente. La più comune per uso generale.",
    version1Body: "Generata da timestamp e dati della macchina.",
    generateUuid: "Genera UUID",
    generateUuids: "Genera UUID",
    results: "Risultati",
    copyAll: "Copia tutto",
  },
  hu: {
    outputResult: "Eredmény",
    invalidInput: "Érvénytelen bemenet",
    copyOutput: "Kimenet másolása",
    textToEncode: "Kódolandó szöveg",
    base64ToDecode: "Dekódolandó Base64",
    enterTextToEncode: "Írd be a kódolandó szöveget...",
    enterBase64ToDecode: "Írd be a dekódolandó Base64 karakterláncot...",
    encodeToBase64: "Kódolás Base64-be",
    decodeFromBase64: "Dekódolás Base64-ből",
    urlToEncode: "Kódolandó URL",
    encodedUrlToDecode: "Dekódolandó kódolt URL",
    encodeUrl: "URL kódolása",
    decodeUrl: "URL dekódolása",
    uuidVersion: "UUID verzió",
    quantity: "Mennyiség",
    aboutUuidVersions: "Az UUID verziókról",
    version4Body: "Véletlenszerűen generált. A leggyakoribb általános használatra.",
    version1Body: "Időbélyegből és gépadatokból generált.",
    generateUuid: "UUID generálása",
    generateUuids: "UUID-k generálása",
    results: "Eredmények",
    copyAll: "Összes másolása",
  },
  ms: {
    outputResult: "Hasil",
    invalidInput: "Input tidak sah",
    copyOutput: "Salin hasil",
    textToEncode: "Teks untuk dikodkan",
    base64ToDecode: "Base64 untuk dinyahkod",
    enterTextToEncode: "Masukkan teks untuk dikodkan...",
    enterBase64ToDecode: "Masukkan rentetan Base64 untuk dinyahkod...",
    encodeToBase64: "Kodkan ke Base64",
    decodeFromBase64: "Nyahkod dari Base64",
    urlToEncode: "URL untuk dikodkan",
    encodedUrlToDecode: "URL berkod untuk dinyahkod",
    encodeUrl: "Kodkan URL",
    decodeUrl: "Nyahkod URL",
    uuidVersion: "Versi UUID",
    quantity: "Kuantiti",
    aboutUuidVersions: "Tentang versi UUID",
    version4Body: "Dijana secara rawak. Paling biasa untuk kegunaan umum.",
    version1Body: "Dijana daripada cap masa dan data mesin.",
    generateUuid: "Jana UUID",
    generateUuids: "Jana UUID",
    results: "Keputusan",
    copyAll: "Salin semua",
  },
  nl: {
    outputResult: "Resultaat",
    invalidInput: "Ongeldige invoer",
    copyOutput: "Resultaat kopiëren",
    textToEncode: "Tekst om te coderen",
    base64ToDecode: "Base64 om te decoderen",
    enterTextToEncode: "Voer tekst in om te coderen...",
    enterBase64ToDecode: "Voer een Base64-reeks in om te decoderen...",
    encodeToBase64: "Coderen naar Base64",
    decodeFromBase64: "Decoderen vanuit Base64",
    urlToEncode: "URL om te coderen",
    encodedUrlToDecode: "Gecodeerde URL om te decoderen",
    encodeUrl: "URL coderen",
    decodeUrl: "URL decoderen",
    uuidVersion: "UUID-versie",
    quantity: "Aantal",
    aboutUuidVersions: "Over UUID-versies",
    version4Body: "Willekeurig gegenereerd. Het meest gebruikelijk voor algemeen gebruik.",
    version1Body: "Gegenereerd op basis van tijdstempel en machinegegevens.",
    generateUuid: "UUID genereren",
    generateUuids: "UUID's genereren",
    results: "Resultaten",
    copyAll: "Alles kopiëren",
  },
  pl: {
    outputResult: "Wynik",
    invalidInput: "Nieprawidłowe dane",
    copyOutput: "Kopiuj wynik",
    textToEncode: "Tekst do zakodowania",
    base64ToDecode: "Base64 do odkodowania",
    enterTextToEncode: "Wpisz tekst do zakodowania...",
    enterBase64ToDecode: "Wpisz ciąg Base64 do odkodowania...",
    encodeToBase64: "Zakoduj do Base64",
    decodeFromBase64: "Odkoduj z Base64",
    urlToEncode: "URL do zakodowania",
    encodedUrlToDecode: "Zakodowany URL do odkodowania",
    encodeUrl: "Zakoduj URL",
    decodeUrl: "Odkoduj URL",
    uuidVersion: "Wersja UUID",
    quantity: "Ilość",
    aboutUuidVersions: "O wersjach UUID",
    version4Body: "Generowany losowo. Najczęściej używany do ogólnych zastosowań.",
    version1Body: "Generowany na podstawie znacznika czasu i danych maszyny.",
    generateUuid: "Generuj UUID",
    generateUuids: "Generuj UUID",
    results: "Wyniki",
    copyAll: "Kopiuj wszystko",
  },
  pt: {
    outputResult: "Resultado",
    invalidInput: "Entrada inválida",
    copyOutput: "Copiar resultado",
    textToEncode: "Texto para codificar",
    base64ToDecode: "Base64 para decodificar",
    enterTextToEncode: "Digite o texto para codificar...",
    enterBase64ToDecode: "Digite a string Base64 para decodificar...",
    encodeToBase64: "Codificar para Base64",
    decodeFromBase64: "Decodificar de Base64",
    urlToEncode: "URL para codificar",
    encodedUrlToDecode: "URL codificada para decodificar",
    encodeUrl: "Codificar URL",
    decodeUrl: "Decodificar URL",
    uuidVersion: "Versão UUID",
    quantity: "Quantidade",
    aboutUuidVersions: "Sobre as versões UUID",
    version4Body: "Gerada aleatoriamente. A mais comum para uso geral.",
    version1Body: "Gerada a partir de carimbo de data/hora e dados da máquina.",
    generateUuid: "Gerar UUID",
    generateUuids: "Gerar UUIDs",
    results: "Resultados",
    copyAll: "Copiar tudo",
  },
  th: {
    outputResult: "ผลลัพธ์",
    invalidInput: "ข้อมูลไม่ถูกต้อง",
    copyOutput: "คัดลอกผลลัพธ์",
    textToEncode: "ข้อความที่จะเข้ารหัส",
    base64ToDecode: "Base64 ที่จะถอดรหัส",
    enterTextToEncode: "ป้อนข้อความที่จะเข้ารหัส...",
    enterBase64ToDecode: "ป้อนสตริง Base64 ที่จะถอดรหัส...",
    encodeToBase64: "เข้ารหัสเป็น Base64",
    decodeFromBase64: "ถอดรหัสจาก Base64",
    urlToEncode: "URL ที่จะเข้ารหัส",
    encodedUrlToDecode: "URL ที่เข้ารหัสแล้วสำหรับถอดรหัส",
    encodeUrl: "เข้ารหัส URL",
    decodeUrl: "ถอดรหัส URL",
    uuidVersion: "เวอร์ชัน UUID",
    quantity: "จำนวน",
    aboutUuidVersions: "เกี่ยวกับเวอร์ชัน UUID",
    version4Body: "สร้างแบบสุ่ม ใช้บ่อยที่สุดสำหรับงานทั่วไป",
    version1Body: "สร้างจากเวลาและข้อมูลเครื่อง",
    generateUuid: "สร้าง UUID",
    generateUuids: "สร้าง UUID",
    results: "ผลลัพธ์",
    copyAll: "คัดลอกทั้งหมด",
  },
  tr: {
    outputResult: "Çıktı",
    invalidInput: "Geçersiz giriş",
    copyOutput: "Çıktıyı kopyala",
    textToEncode: "Kodlanacak metin",
    base64ToDecode: "Çözülecek Base64",
    enterTextToEncode: "Kodlanacak metni girin...",
    enterBase64ToDecode: "Çözülecek Base64 dizesini girin...",
    encodeToBase64: "Base64'e kodla",
    decodeFromBase64: "Base64'ten çöz",
    urlToEncode: "Kodlanacak URL",
    encodedUrlToDecode: "Çözülecek kodlanmış URL",
    encodeUrl: "URL kodla",
    decodeUrl: "URL çöz",
    uuidVersion: "UUID sürümü",
    quantity: "Adet",
    aboutUuidVersions: "UUID sürümleri hakkında",
    version4Body: "Rastgele üretilir. Genel kullanım için en yaygın seçenektir.",
    version1Body: "Zaman damgası ve makine verilerinden üretilir.",
    generateUuid: "UUID oluştur",
    generateUuids: "UUID oluştur",
    results: "Sonuçlar",
    copyAll: "Tümünü kopyala",
  },
  el: {
    outputResult: "Αποτέλεσμα",
    invalidInput: "Μη έγκυρη είσοδος",
    copyOutput: "Αντιγραφή αποτελέσματος",
    textToEncode: "Κείμενο για κωδικοποίηση",
    base64ToDecode: "Base64 για αποκωδικοποίηση",
    enterTextToEncode: "Εισαγάγετε κείμενο για κωδικοποίηση...",
    enterBase64ToDecode: "Εισαγάγετε συμβολοσειρά Base64 για αποκωδικοποίηση...",
    encodeToBase64: "Κωδικοποίηση σε Base64",
    decodeFromBase64: "Αποκωδικοποίηση από Base64",
    urlToEncode: "URL για κωδικοποίηση",
    encodedUrlToDecode: "Κωδικοποιημένο URL για αποκωδικοποίηση",
    encodeUrl: "Κωδικοποίηση URL",
    decodeUrl: "Αποκωδικοποίηση URL",
    uuidVersion: "Έκδοση UUID",
    quantity: "Ποσότητα",
    aboutUuidVersions: "Σχετικά με τις εκδόσεις UUID",
    version4Body: "Δημιουργείται τυχαία. Η πιο συνηθισμένη για γενική χρήση.",
    version1Body: "Δημιουργείται από χρονική σήμανση και δεδομένα συσκευής.",
    generateUuid: "Δημιουργία UUID",
    generateUuids: "Δημιουργία UUID",
    results: "Αποτελέσματα",
    copyAll: "Αντιγραφή όλων",
  },
  uk: {
    outputResult: "Результат",
    invalidInput: "Неприпустимі дані",
    copyOutput: "Копіювати результат",
    textToEncode: "Текст для кодування",
    base64ToDecode: "Base64 для декодування",
    enterTextToEncode: "Введіть текст для кодування...",
    enterBase64ToDecode: "Введіть рядок Base64 для декодування...",
    encodeToBase64: "Кодувати в Base64",
    decodeFromBase64: "Декодувати з Base64",
    urlToEncode: "URL для кодування",
    encodedUrlToDecode: "Закодований URL для декодування",
    encodeUrl: "Кодувати URL",
    decodeUrl: "Декодувати URL",
    uuidVersion: "Версія UUID",
    quantity: "Кількість",
    aboutUuidVersions: "Про версії UUID",
    version4Body: "Генерується випадково. Найпоширеніший варіант для загального використання.",
    version1Body: "Генерується з часової мітки та даних машини.",
    generateUuid: "Створити UUID",
    generateUuids: "Створити UUID",
    results: "Результати",
    copyAll: "Копіювати все",
  },
  ru: {
    outputResult: "Результат",
    invalidInput: "Недопустимый ввод",
    copyOutput: "Копировать результат",
    textToEncode: "Текст для кодирования",
    base64ToDecode: "Base64 для декодирования",
    enterTextToEncode: "Введите текст для кодирования...",
    enterBase64ToDecode: "Введите строку Base64 для декодирования...",
    encodeToBase64: "Кодировать в Base64",
    decodeFromBase64: "Декодировать из Base64",
    urlToEncode: "URL для кодирования",
    encodedUrlToDecode: "Закодированный URL для декодирования",
    encodeUrl: "Кодировать URL",
    decodeUrl: "Декодировать URL",
    uuidVersion: "Версия UUID",
    quantity: "Количество",
    aboutUuidVersions: "О версиях UUID",
    version4Body: "Генерируется случайно. Самый частый вариант для общего использования.",
    version1Body: "Создается из временной метки и данных машины.",
    generateUuid: "Создать UUID",
    generateUuids: "Создать UUID",
    results: "Результаты",
    copyAll: "Копировать все",
  },
  ar: {
    outputResult: "النتيجة",
    invalidInput: "إدخال غير صالح",
    copyOutput: "نسخ النتيجة",
    textToEncode: "النص المطلوب ترميزه",
    base64ToDecode: "Base64 المطلوب فك ترميزه",
    enterTextToEncode: "أدخل النص المطلوب ترميزه...",
    enterBase64ToDecode: "أدخل سلسلة Base64 المطلوب فك ترميزها...",
    encodeToBase64: "ترميز إلى Base64",
    decodeFromBase64: "فك الترميز من Base64",
    urlToEncode: "رابط URL المطلوب ترميزه",
    encodedUrlToDecode: "رابط URL المشفر المطلوب فك ترميزه",
    encodeUrl: "ترميز URL",
    decodeUrl: "فك ترميز URL",
    uuidVersion: "إصدار UUID",
    quantity: "الكمية",
    aboutUuidVersions: "حول إصدارات UUID",
    version4Body: "يتم إنشاؤه عشوائيًا. الأكثر شيوعًا للاستخدام العام.",
    version1Body: "يتم إنشاؤه من الطابع الزمني وبيانات الجهاز.",
    generateUuid: "إنشاء UUID",
    generateUuids: "إنشاء UUID",
    results: "النتائج",
    copyAll: "نسخ الكل",
  },
  ko: {
    outputResult: "출력 결과",
    invalidInput: "유효하지 않은 입력",
    copyOutput: "결과 복사",
    textToEncode: "인코딩할 텍스트",
    base64ToDecode: "디코딩할 Base64",
    enterTextToEncode: "인코딩할 텍스트를 입력하세요...",
    enterBase64ToDecode: "디코딩할 Base64 문자열을 입력하세요...",
    encodeToBase64: "Base64로 인코딩",
    decodeFromBase64: "Base64에서 디코딩",
    urlToEncode: "인코딩할 URL",
    encodedUrlToDecode: "디코딩할 인코딩된 URL",
    encodeUrl: "URL 인코딩",
    decodeUrl: "URL 디코딩",
    uuidVersion: "UUID 버전",
    quantity: "수량",
    aboutUuidVersions: "UUID 버전 정보",
    version4Body: "무작위로 생성됩니다. 일반적인 용도로 가장 많이 사용됩니다.",
    version1Body: "타임스탬프와 기기 데이터로 생성됩니다.",
    generateUuid: "UUID 생성",
    generateUuids: "UUID 생성",
    results: "결과",
    copyAll: "모두 복사",
  },
  ja: {
    outputResult: "出力結果",
    invalidInput: "無効な入力です",
    copyOutput: "結果をコピー",
    textToEncode: "エンコードするテキスト",
    base64ToDecode: "デコードする Base64",
    enterTextToEncode: "エンコードするテキストを入力してください...",
    enterBase64ToDecode: "デコードする Base64 文字列を入力してください...",
    encodeToBase64: "Base64 にエンコード",
    decodeFromBase64: "Base64 からデコード",
    urlToEncode: "エンコードする URL",
    encodedUrlToDecode: "デコードするエンコード済み URL",
    encodeUrl: "URL をエンコード",
    decodeUrl: "URL をデコード",
    uuidVersion: "UUID バージョン",
    quantity: "数量",
    aboutUuidVersions: "UUID バージョンについて",
    version4Body: "ランダムに生成されます。一般用途で最もよく使われます。",
    version1Body: "タイムスタンプとマシンデータから生成されます。",
    generateUuid: "UUID を生成",
    generateUuids: "UUID を生成",
    results: "結果",
    copyAll: "すべてコピー",
  },
  ro: {
    outputResult: "Rezultat",
    invalidInput: "Input nevalid",
    copyOutput: "Copiază rezultatul",
    textToEncode: "Text de codificat",
    base64ToDecode: "Base64 de decodificat",
    enterTextToEncode: "Introdu textul de codificat...",
    enterBase64ToDecode: "Introdu șirul Base64 de decodificat...",
    encodeToBase64: "Codifică în Base64",
    decodeFromBase64: "Decodifică din Base64",
    urlToEncode: "URL de codificat",
    encodedUrlToDecode: "URL codificat de decodificat",
    encodeUrl: "Codifică URL",
    decodeUrl: "Decodifică URL",
    uuidVersion: "Versiune UUID",
    quantity: "Cantitate",
    aboutUuidVersions: "Despre versiunile UUID",
    version4Body: "Generată aleatoriu. Cea mai comună pentru uz general.",
    version1Body: "Generată din marcaj temporal și date ale mașinii.",
    generateUuid: "Generează UUID",
    generateUuids: "Generează UUID-uri",
    results: "Rezultate",
    copyAll: "Copiază tot",
  },
};

export function getDevToolCopy(locale: Locale): DevToolCopy {
  return { ...en, ...(overrides[locale] ?? {}) };
}
